function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Box from '../Box';
import { FormGroupContext } from './FormGroup';
const hasFormError = (name, form) => {
  return form && form.touched && form.touched[name] && form.errors && form.errors[name];
};
const Textarea = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    field,
    form,
    hasError: _hasError,
    hasPrefix,
    hasSuffix,
    rows = 5,
    ...props
  } = _ref;
  const hasError = field ? hasFormError(field.name, form) : _hasError;
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: "textarea",
    tx: "forms",
    variant: "input",
    id: React.useContext(FormGroupContext),
    rows: rows
  }, field, props, {
    __css: {
      display: 'block',
      width: '100%',
      py: 2,
      px: 2,
      appearance: 'none',
      bg: props.disabled ? 'gray.2' : 'white',
      cursor: props.disabled ? 'not-allowed' : 'text',
      border: hasError ? 'error' : 'default',
      borderTopLeftRadius: hasPrefix ? 'none' : 'corner',
      borderBottomLeftRadius: hasPrefix ? 'none' : 'corner',
      borderTopRightRadius: hasSuffix ? 'none' : 'corner',
      borderBottomRightRadius: hasSuffix ? 'none' : 'corner',
      '&:hover': {
        borderColor: hasError ? 'red' : 'gray.5'
      },
      '&:focus': {
        borderColor: hasError ? 'red' : 'secondary',
        outline: 'none'
      }
    }
  }));
});
Textarea.propTypes = {};
Textarea.displayName = 'Textarea';
export default Textarea;